module.exports = __webpack_public_path__ + "static/media/add-expect-iocn.8b528358.svg";